var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReDiseno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.54 69.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72,59.29l-57.56,0A6.23,6.23,0,0,1,8.26,53l0-36.56a6.23,6.23,0,0,1,6.22-6.22l57.56,0a6.23,6.23,0,0,1,6.22,6.22l0,36.56A6.23,6.23,0,0,1,72,59.29Zm-57.54-46a3.23,3.23,0,0,0-3.22,3.22l0,36.56a3.22,3.22,0,0,0,3.22,3.22l57.56,0a3.23,3.23,0,0,0,3.22-3.22l0-36.56a3.22,3.22,0,0,0-3.22-3.22Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.78,
    y: 18.83,
    width: 30,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.78,
    y: 18.81,
    width: 6,
    height: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.27,
    y: 33.78,
    width: 12.5,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.27,
    y: 39.78,
    width: 12.5,
    height: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.27,
    y: 27.78,
    width: 12.5,
    height: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.18,41.82H20.36a1.59,1.59,0,0,1-1.59-1.59V28.4a1.59,1.59,0,0,1,1.59-1.59H47.18a1.6,1.6,0,0,1,1.59,1.6V40.24A1.59,1.59,0,0,1,47.18,41.82Zm-26.41-2h26v-11h-26Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.76,
    y: 47.82,
    width: 17,
    height: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReDiseno);
export default __webpack_public_path__ + "static/media/Icon-ReDiseno.59d0bcd1def170521bd9f77003db2a10.svg";
export { ForwardRef as ReactComponent };